import {isBoolean} from "lodash/lang";

export default {
    state: {
        customerDetails: {
            email: '',
            name: '',
            phone: '',
            surname: '',
        },
        recipientDetails: {
            email: '',
            name: '',
            phone: '',
            surname: '',
        },
        isOtherRecipient: false,
    },
    getters: {
        isOtherRecipient: (state) => state.isOtherRecipient,
        isCustomerFormComplete(state) {
            return !!state.customerDetails?.firstname &&
                !!state.customerDetails?.lastname &&
                !!state.customerDetails?.phone &&
                !!state.customerDetails?.email
        },
        isRecipientFormComplete(state) {
            return !!state.recipientDetails.firstname &&
                !!state.recipientDetails.lastname &&
                !!state.recipientDetails.phone &&
                !!state.recipientDetails.email
        },
        getCustomerDetails: (state) => state.customerDetails,
        // getRecipientDetails: (state) => state.recipientDetails
    },
    mutations: {
        setCustomerDetails: (state, details) => {
            state.customerDetails = JSON.parse(JSON.stringify(details))
            !state.isOtherRecipient && (state.recipientDetails = JSON.parse(JSON.stringify(details)))
        },
        setRecipientDetails: (state, details) => {
            state.recipientDetails = JSON.parse(JSON.stringify(details))
        },
        setIsOtherRecipient: (state, value) => {
            isBoolean(value) && (state.isOtherRecipient = value)
        },
    }
}
